import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ListItemTransactionType} from "../../definitions/types";

export const name = "listItemTransaction";

type ListItemTransactionStateType = {
    value?: ListItemTransactionType
};

const listItemTransactionSlice = createSlice({
    name: name,
    initialState: {value: undefined} as ListItemTransactionStateType,
    reducers: {
        set: (state, action: PayloadAction<ListItemTransactionType>) => {
            state.value = action.payload;
        },
        clear: (state) => {
            state.value = undefined;
        }
    }
});

export const {
    set: setListItemTransaction,
    clear: clearListItemTransaction
} = listItemTransactionSlice.actions;
export default listItemTransactionSlice.reducer;